import Image from 'next/image';
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'
interface HomeMeetProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	background_desktop?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
	background_mobile?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
	images?: {
		images_id: {
			alt: string
			image_file: {
				image: {
					id: string
					filename_download: string
				}
			}
		}
	}[]
	button?: {
		href: string
		label: string
	}
}

export const fields = [
	'heading.title',
	'text.text',
	'background_desktop.alt',
	'background_desktop.image_file.image.id',
	'background_desktop.image_file.image.filename_download',
	'background_mobile.alt',
	'background_mobile.image_file.image.id',
	'background_mobile.image_file.image.filename_download',

	'images.images_id.alt',
	'images.images_id.image_file.image.id',
	'images.images_id.image_file.image.filename_download',

	'button.href',
	'button.label',
]
export default function HomeMeet({ data }: { data: HomeMeetProps }) {
  return (
		<>
			<section className='relative overflow-hidden py-[3rem] lg:hidden block'>
				<div className='container relative'>
					<div className='space-y-4'>
						<div className='font-agopus text-4xl text-black'>{data?.heading?.title || ''}</div>
					</div>
				</div>
			</section>
			<section className='HomeMeet relative overflow-hidden py-[8rem] max-md:py-0 max-[1300px]:pb-0 bg-neutral-50 max-md:rounded-tl-[50px]'>
				{/* Background Image */}
				<picture className='absolute inset-0 z-0 w-full h-full max-md:relative max-md:h-[380px] max-md:block'>
					<source
						srcSet={getReadableImageUrl(
							data?.background_desktop?.image_file?.image?.id || '',
							data?.background_desktop?.image_file?.image?.filename_download ||
								''
						)}
						media='(min-width: 580px)'
						type='image/webp'
					/>
					<Image
						src={getReadableImageUrl(
							data?.background_mobile?.image_file?.image?.id || '',
							data?.background_mobile?.image_file?.image?.filename_download ||
								''
						)}
						alt={data?.background_mobile?.alt || ''}
						fill
						sizes='100vw'
						className='object-cover object-center max-[1500px]:object-[70%_0]'
						priority
					/>
				</picture>

				{/* Overlay for mobile */}
				<div className='absolute inset-0 bg-gradient-to-b from-neutral-50 via-neutral-50/95 to-neutral-50/95 sm:bg-gradient-to-r sm:from-neutral-50 sm:via-neutral-50/95 sm:to-transparent hidden'></div>

				<div className='container relative max-md:mt-[-3rem]'>
					<div className='flex flex-col lg:flex-row'>
						{/* Content Box */}
						<div className='w-full lg:w-1/2 flex flex-col gap-8 relative z-10'>
							{/* Logo */}
							<div className='relative w-20 h-20'>
								<Image
									src='/images/logo_h.svg'
									alt='Harmon Logo'
									fill
									sizes='5rem'
									className='object-contain'
								/>
							</div>

							{/* Heading */}
							<h2 className='lg:block hidden'>{data?.heading?.title || ''}</h2>

							{/* Education Section */}
							<div
								className='grid gap-8'
								dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
							/>
						</div>
					</div>
				</div>
				{/* Awards Section */}
				<div className='xl:absolute xl:right-0 xl:bottom-[8.4375rem] relative mx-auto flex flex-wrap items-center justify-center gap-8 xl:bg-white py-[1.5625rem] px-[1.5625rem] xl:rounded-l-[0.625rem] xl:rounded-[0.625rem] xl:shadow-sm xl:ml-auto max-w-[33.75rem] my-5'>
					{data?.images?.map((image, index) => (
						<a
							key={index}
							//href='#'
							className='relative w-20 h-20 md:w-[4.8rem] md:h-[4.8rem] transition-opacity hover:opacity-80'
							target='_blank'
							rel='noopener noreferrer'
						>
							<Image
								src={getReadableImageUrl(
									image.images_id.image_file.image.id || '',
									image.images_id.image_file.image.filename_download || ''
								)}
								alt={image.images_id.alt || ''}
								fill
								sizes='5rem'
								className='object-contain'
							/>
						</a>
					))}
				</div>

				{/* CTA Button */}
				{data?.button && (
					<div className='container relative flex mt-5 max-md:mb-12'>
						<a
							href={data.button.href}
							className='btn'
						>{data.button.label}
						</a>
					</div>
				)}
			</section>
		</>
	)
} 